import './index.scss';

import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from 'Redux/store';

import App from './App.jsx';
import Loader from 'ViatoUi/Shared/Loader';

ReactDOM.render(
	<React.StrictMode>
		<Suspense fallback={<Loader />}>
			<Provider store={store}>
				<App />
			</Provider>
		</Suspense>
	</React.StrictMode>,
	document.getElementById('viato-contract-generator')
);
